import { Injectable } from "@angular/core";

import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { SalesHistoryRepository } from "../../repositories/pbm/sales-history.repository";
import { SalesHistoryCompany } from "../../models/domains/pbm/sales-history/sales-history-company";

@Injectable({ providedIn: "root" })
export class SalesHistoryService {
  constructor(private salesHistoryRepository: SalesHistoryRepository) {}

  public async findSalesHistory(filterText: string, pagingRequest: PagingRequest): Promise<PageableResult> {
    return await this.salesHistoryRepository.findSalesHistory(filterText, pagingRequest);
  }

  public async findSalesHistoryByFiscalNumber(pagingRequest: PagingRequest): Promise<SalesHistoryCompany> {
    return await this.salesHistoryRepository.findSalesHistoryByFiscalNumber(pagingRequest);
  }
}
